import { render, staticRenderFns } from "./CurriculumJournalRow.vue?vue&type=template&id=131b9e08&scoped=true&"
import script from "./CurriculumJournalRow.vue?vue&type=script&lang=ts&"
export * from "./CurriculumJournalRow.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumJournalRow.vue?vue&type=style&index=0&id=131b9e08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b9e08",
  null
  
)

export default component.exports